import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { navigation } from "./telemetry";

export function TelemetryNavigation() {
  const { pathname } = useLocation();
  useEffect(() => { navigation(pathname); }, [pathname]);
  return null;
}
